import styled, {DefaultTheme, StyledComponentProps} from 'styled-components';
import {Typography} from '../typography/typography';
import {LinkProps, Link as RouterLink} from 'react-router-dom';

export interface TKind extends LinkProps {
  kind?: 'black' | 'blue';
}

export type TLinkProps = StyledComponentProps<
  'a',
  DefaultTheme,
  {
    href?: string;
    onClick?: () => void;
    kind?: 'black' | 'blue';
  },
  never
>;

export const Link = styled(RouterLink)<TKind>`
  ${Typography};

  font-size: 14px;
  color: ${({kind, theme}) =>
    kind === 'black' ? theme.colors.textMedium : theme.colors.purple300};
  text-decoration: none;
  transition: all ease-in-out 300ms;
  position: relative;

  &:hover {
    color: ${({kind, theme}) =>
      kind === 'black' ? theme.colors.textDark : theme.colors.purple300};

    text-decoration: underline;
  }
`;
